import { PaymentOptions, RebookingPaymentStatus, RebookingPaymentStatusValues } from '../types'
import { isBookingFullyPaid } from './fullyPaidBooking'

export function getRebookingPaymentStatus(paymentOptions: PaymentOptions): RebookingPaymentStatus {
  if (isBookingFullyPaid(paymentOptions)) {
    return RebookingPaymentStatusValues.FULLY_COVERED
  }

  if (paymentOptions.downPaymentAlreadyCovered) {
    return RebookingPaymentStatusValues.DOWN_PAYMENT_COVERED
  }

  return (paymentOptions.amountAlreadyPaid && paymentOptions.amountAlreadyPaid > 0) ? RebookingPaymentStatusValues.PARTIALLY_COVERED : RebookingPaymentStatusValues.NOT_PAID
}
